import { AfterViewInit, Component, EventEmitter, Input,  OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  StepperActivateEvent,
  StepperComponent,
} from "@progress/kendo-angular-layout";
// Update the import path if the file is located elsewhere, for example:
import { BeforeValidateClickEvent, supplierStatutChangeEvent } from '../../../COMPOSANTS/supplier-validation-toolbar/supplier-validation-toolbar.component';
// Or verify the correct relative path to the component file.
import { SuppliersService, SharedDataService, ExtUsersService, ContactsService } from '../../../all-services';
import {
  Supplier,
  SimpleReponseResult,
  SupplierStatut,
  ExtUser,
  SupplierScreenStep,
  detailSupplierScreenValidity,
  SaveStepParam,
  Contact,
  InseeEtablissement,
  SupplierDescriptif,
  StepLabelIcon,
  SupplierWF
} from '../../../all-models';
import { Observable, Subject, Subscription, forkJoin } from 'rxjs';
import { PilotageEndelContainerDirective, PilotageEndelContainerLoaderEvent } from '../../../all-directives';

import { map, tap } from 'rxjs/operators';
import { NgForm } from '@angular/forms';


import { infoCircleIcon,  calculatorIcon, gearsIcon, filesErrorIcon, fileWordIcon, trackChangesAcceptAllIcon } from "@progress/kendo-svg-icons";


@Component({
  selector: 'app-supplier-details',
  templateUrl: './supplier-details.component.html',
  styleUrls: ['./supplier-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SupplierDetailsComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  //public id: number = 0;
  @Input() supplierId?: number;

  @ViewChild('ngfrmvalidstatut') ngfrmvalidstatut: NgForm;

  public subscriptions: Subscription[] = [];
  private _supplier: Supplier = new Supplier();

  get supplier(): Supplier {
    return this._supplier;
  }
  set supplier(value: Supplier) {
    this._supplier = value;
  }

  // Un fournisseur est considéré suspendu s'il a été  référencé en amont
  get isSuspendedSupplier(): boolean {
    return (this.supplierStatutCod == '900' && this.previousWf?.StatutId == 10);
  }

  public validatedSteps: number[] = [];
  public saveUnlock: boolean = false;
  public fromScreen?: string;
  public initialTab?: string;

  public validationComment: string = '';

  public windowsValid: any = {
    _visible: false,
    get visible(): boolean {
      return this._visible;
    },
    set visible(value: boolean) {
      this._visible = value;
    },
    width: 700,
    height: 400,
    state: 'default'
  }

  private firstLoad: boolean = true;
  get readonly(): boolean {
    if (this.sharedDataSvc.profil?.Cod == 'ADMIN') {
      return false;
    }
    if (this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR') {
      return (['100', '150'].indexOf(this.supplierStatutCod) < 0);
    } else {
      return (this.supplierStatutCod >= '200');// && (this.sharedDataSvc.profil?.Cod!='ADMIN');
    }
  }



  private _stepsLabelIcon: StepLabelIcon[] = [
    { labelCod: "Descriptif", svgIcon: infoCircleIcon },
    //{ labelCod: "Descriptif", iconClass:  "fas fa-info fa-2x" },
    { labelCod: "Informations_comptables", svgIcon: calculatorIcon },
    { labelCod: "Savoir_faire", svgIcon: gearsIcon },
    { labelCod: "Documents_reglementaires", svgIcon: filesErrorIcon },
    { labelCod: "Documents_qualite", svgIcon: fileWordIcon },
    { labelCod: "RSE", label: "RSE", imgSrc: "./assets/images/RSE-80x80.png" },
    { labelCod: "Recapitulatif", svgIcon: trackChangesAcceptAllIcon },
    { labelCod: "Pilotage_ENDEL", iconClass: "fas fa-euro-sign fa-2x" },
  ]
  private internalSteps: SupplierScreenStep[] = [];

  constructor(
    private route: ActivatedRoute,
    private suppliersSvc: SuppliersService,
    private extUsersSvc: ExtUsersService,
    public sharedDataSvc: SharedDataService,
    public contactsSvc: ContactsService,
    private router: Router
  ) { }

  @ViewChild(PilotageEndelContainerDirective, { static: false }) pilotageEndelContainer!: PilotageEndelContainerDirective;

  pilotageEndelLoaded: boolean = false;
  reloadPilotageEndel(supplier: Supplier, force:boolean): void {
    if (this.pilotageEndelLoaded && !force) return;
    if (supplier) {
      let eventParam: PilotageEndelContainerLoaderEvent = new PilotageEndelContainerLoaderEvent();
      eventParam.container = this.pilotageEndelContainer;
      eventParam.supplier = supplier;
      this.sharedDataSvc.loadPilotageEndel.emit(eventParam);
      this.pilotageEndelLoaded = true;
    }
  }

  ngAfterViewInit(): void {
    if (this.showPilotageEndel) {
      this.reloadPilotageEndel(this.supplier,false);  
    }
  }

  get supplierTitle(): string {
    if (!this.supplier) return '';
    const Sep = (this.supplier?.NumTiers || '') == '' ? '' : ' - ';
    return (this.supplier?.NumTiers || '') + Sep + this.supplier?.SupplierName;
  }


  public demandeur?: Contact = null;

  initInternalSteps(): void {
    this.internalSteps = [];
    this._stepsLabelIcon.forEach((item: StepLabelIcon, index: number) => {
      if (item.labelCod) {        
        item.label = this.sharedDataSvc.getLoadedLabel(item.labelCod);
      }
      let screenStep: SupplierScreenStep =
        new SupplierScreenStep(this.sharedDataSvc, item, index, () => this.readonly);
      this.subscriptions.push(screenStep.stepSaved.subscribe((result: SaveStepParam) => {
        this.stepSaved(result);
      }));
      screenStep.canModifySupplier = (): any => {
        return this.canModifySupplier();
      };
      this.internalSteps.push(screenStep);
    });
  }



  ngOnInit(): void {
    if (!this.sharedDataSvc.allListsLoaded) {
      this.subscriptions.push(this.sharedDataSvc.allListsLoadedChange.subscribe(res => {
        this.initInternalSteps();
      }));
    } else {
      this.initInternalSteps();
    }

    //this.initInternalSteps();
    this.fromScreen = this.route.snapshot.paramMap.get('fromscreen');
    this.initialTab = this.route.snapshot.paramMap.get('initialTab') || undefined;
    this._loadSupplierWhenProfilLoaded();
  }

  ngOnDestroy(): void {
    while (this.subscriptions.length > 0) {
      this.subscriptions.pop().unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['supplierId'] && this.supplierId !== undefined) {
      this._loadSupplierWhenProfilLoaded();
    }
  }

  private _loadSupplierWhenProfilLoaded(): void {
    if (!this.sharedDataSvc.profil) {
      this.subscriptions.push(this.sharedDataSvc.loggedProfilChange.subscribe(res => {
        this._loadSupplierWhenProfilLoaded();
      }));
    } else {
      let id: number;
      if (this.supplierId) {
        id = this.supplierId;
      } else {
        id = Number(this.route.snapshot.paramMap.get('id'));
        this.supplierId = id;
        this.initSupplierFromId(id);
      }
    }
  }

  public get steps(): SupplierScreenStep[] {
    if (this.sharedDataSvc.portalType == 'EXTRANET' || this.supplierStatutCod < '800' || !this.isProfilAllowedToPilotage) {
      return this.internalSteps.filter(item => item.labelCod != 'Pilotage_ENDEL');;
    } else {
      return this.internalSteps;
    }
  }

  public get stepsLoaded():boolean {
    return this.steps?.length>0;
  }

  public get showPilotageEndel():boolean {
    return this.steps.find(s=>s.labelCod=='Pilotage_ENDEL')!=undefined;
  }
  
  public get currentStepObject(): SupplierScreenStep | undefined {
    if (!this.stepsLoaded) {
      return undefined;
    }
    return this.steps[this.currentStep];
  }

  public get debugSteps(): any[] {
    return this.steps.map(s => {
      return {
        label: s.label,
        isValid: s.screenValidity.isValid,
        index: s.index
      };
    });
  }

  public get currentStep(): number {
    return this.supplier.RefStep|| 0;
  }
  public set currentStep(value: number) {
    if (this.supplier.RefStep != value) {
      this.supplier.RefStep = value;
      this.lockSaveButton();
      if (this.currentStepObject?.label == 'Pilotage_ENDEL') {
        this.sharedDataSvc.pilotageEndelIsActivated.emit();
      }
    }
  }

  get isProfilAllowedToPilotage(): boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL');
    //return this.sharedDataSvc.profil?.Cod && ['COMPTA', 'ASSISTANT', 'CONSULT', 'DEMAT', 'FOURNISSEUR', 'DEMANDEUR'].indexOf(this.sharedDataSvc.profil?.Cod) < 0;
  }


  initSupplierFromId(id: number, persisitingScreen: boolean = false): void {
    if (id === undefined) return;
    this.subscriptions.push(this.initSupplier(id, persisitingScreen)
      .subscribe({
        next: res => {
          if (res) {
            if (this.firstLoad) this.firstLoad = false;
            if (res.InternalContactEmail) {
              this.contactsSvc.ContactByMail(res.InternalContactEmail)
                .subscribe(
                  {
                      next:contact => {
                        this.demandeur = contact;
                      }
                  });
            }
            this._initScreenValiditiesChangeWatchers();
            this.reloadPilotageEndel(res,true);
          }
          this.lockSaveButton();
          this.currentStepObject && this.currentStepObject.supplierReloaded.next(id);
        },
        error: err => {
          this._alertFournisseurInaccesible();
          return;
        }
      })
    );
  }

  previousWf?: SupplierWF;

  private initSupplier(id: number, persisitingScreen: boolean): Observable<Supplier> {
    this.previousWf = undefined;
    return forkJoin([
      this.suppliersSvc.getSupplier(id),
      this.suppliersSvc.GetPreviousWorkFlow(id)])
      .pipe(tap((results) => {
        this.supplier = results[0];
        this.previousWf = results[1];
        if (this.supplier && persisitingScreen) this.supplier.RefStep = this.currentStep;
        if (this.firstLoad || id != this.supplierId) {
          // Au 1er affichage, on se met sur le descriptif par défaut
          this.supplier.RefStep = 0;
          if ((['relances-documentaires', 'list-documentaires', 'list-tasks'].indexOf(this.fromScreen) >= 0)
            || (this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR' && ['800', '900'].indexOf(this.supplierStatut?.Cod) >= 0)) {
            this.supplier.RefStep = this.steps.find(s => s.label == 'Documents_reglementaires')?.index;
          } else if (['list-tasks-knowledge'].indexOf(this.fromScreen) >= 0) {
            this.supplier.RefStep = this.steps.find(s => s.label == 'Savoir_faire')?.index;
          } else if (['list-tasks-knowledge'].indexOf(this.fromScreen) >= 0) {
            this.supplier.RefStep = this.steps.find(s => s.label == 'Savoir_faire')?.index;
          }
        }
        this._loadSupplierCallback(this.supplier);
      }))
      .pipe(map(results => results[0]));
  }

  private _initScreenValiditiesChangeWatchers() {
    this.steps.forEach(s => {
      this.subscriptions.push(
        s.screenValidity.validationChange.subscribe(res => {
          if (!this.steps.find(s => s.screenValidity.isValid == null)) {
            this.allScreensChecked.emit();
          }
          if (!this.steps.find(s => s.screenValidity.isValid != true)) {
            this.allScreensValidated.emit();
          }
        })
      );
    });
  }

  private _alertFournisseurInaccesible(): void {
    this.sharedDataSvc.pafAlert('Msg_acces_fournisseur_non_authorise', (): void => this.redirectToSuppliers());
  }

  private _loadSupplierCallback(supplier: Supplier): void {
    if (!supplier) {
      this._alertFournisseurInaccesible();
      return;
    }
    // Quand on a dupliqué le fournisseur, on reprend les infos INSEE provenant du nouvel identifiant
    if (this.fromScreen == 'duplicated') {
      this.suppliersSvc.GetSupplierInseeEtablissement(supplier, true).subscribe((newEtab: InseeEtablissement) => {
        // on fait une sauvegarde silencieuse de l'établissement Insee issu de la duplication fournisseur
        let parameters: SupplierDescriptif = new SupplierDescriptif();
        Object.keys(parameters).forEach((propName: string) => {
          (<any>parameters)[propName] = (<any>supplier)[propName];
        });
        this.suppliersSvc.patchSupplierDescriptif(supplier?.Id, parameters)
          .subscribe((res: SimpleReponseResult) => {
            if (!res.Ok) {
              this.sharedDataSvc.alert(res.Message);
            }
          });
      });
    }
    this.supplier = supplier;
    if (supplier.SupplierContacts) {
      supplier.SupplierContacts.forEach(sc => {
        if (sc.IsReferent == null) sc.IsReferent = 0;
        if (sc.CreateAccount == null) sc.CreateAccount = 0;
      })
    }
    this.suppliersSvc.rejectIfSiretInactif(supplier)
      .then(() => {
        if (this.sharedDataSvc.portalType == 'EXTRANET' && supplier && supplier.LngCod && supplier.LngCod != this.sharedDataSvc.lngCod) {
          this.sharedDataSvc.changeLanguage(supplier.LngCod);
        }
        if ((this.sharedDataSvc.profil?.Cod == 'CTRL_QUAL' && this.supplierStatutCod == '450')
          || (this.sharedDataSvc.profil?.Cod == 'COMPTA' && this.supplierStatutCod == '550')) {
          this.currentStep = this.steps.find(s => s.label == 'Documents_reglementaires')?.index;
        }
        this.suppliersSvc.onSupplierDeleted.subscribe((result: number) => {
          if (supplier?.Id == result) {
            this.sharedDataSvc.redirectToDefaultScreen(true);
          }
        });
      });
  }

  public shouldValidate = (): boolean => {
    return this.currentStep === 5; //this.steps.length - 1;
  }



  public stepSaved(param: SaveStepParam): void {
    //this.supplier = param.supplier;
    if (param.nextAction == 'previous' || param.nextAction == 'next') {
      this.steps[this.currentStep].screenValidity.isValid = null;
    }
    if (param.nextAction == 'close') {
      if (this.sharedDataSvc.portalType == 'EXTRANET') {
        this.router.navigate([`/folder-saved-info`]);
        return;
      } else {
        this.sharedDataSvc.informe('Dossier sauvegardé', () => this.redirectToSuppliers());
      }
    }
    if (param.nextAction == 'complement' && this.sharedDataSvc.portalType == 'EXTRANET') {
      let validStatutParam: any;
      this.suppliersSvc.SupplierComplement(this.supplier.Id).subscribe((res: SimpleReponseResult) => {
        if (!res.Ok) {
          this.sharedDataSvc.alert(res.Message);
        } else {
          this.router.navigate([`/folder-sent-to-validation`]);
        }
      });
      return;
    }
    if (param.nextAction == 'end') {
      if (this.isExtranetMode) {
        this.suppliersSvc.postSupplierValidation(this.supplier.Id)
          .subscribe((result: SimpleReponseResult) => {
            if (result.Ok) {
              this.router.navigate([`/folder-sent-to-validation`]);
              return;
            } else {
              this.sharedDataSvc.alert(result.Message);
            }
          });
      } else {
        // On verifie si on a un compte externe rattaché au référent. 
        this.suppliersSvc.getExtUser(this.supplier.Id)
          .subscribe(extUser => {
            if (extUser == null) {
              this._creeExtUser();
            } else {
              this._notifyExistingUser(extUser);
            }
          });

      }
    }
    if (param.nextAction == 'screen') {
      this.lockSaveButton();
    }
  }

  private _creeExtUser(): void {
    //On crée le compte utilisateur pour le référent (envoi de mail avec mot de passe provisoire)
    const contactReferentId: number = this.supplier.SupplierContacts.find(sc => sc.IsReferent == 1)?.ContactId;
    this.extUsersSvc.createExtUserFromContact(contactReferentId, this.supplier)
      .subscribe((createdUser: ExtUser) => {
        // Si on est en phase de création par acheteur ou validation fournisseur, le statut suivant sera validation fournisseur, sinon 'a compléter par fournisseur'
        let nextStatutCod: string = this.supplierStatutCod;
        if (['010', '100'].indexOf(this.supplierStatutCod) >= 0) nextStatutCod = '100';
        this.suppliersSvc.ChangeStatutByCod(this.supplier.Id, this.supplier.StatutId, nextStatutCod)
          .subscribe((response: SimpleReponseResult) => {
            this.createPendingAccounts().subscribe((message: string) => {
              this.alertEmailSentAndClose(createdUser, message);
            });
          });
      });
  }

  private _notifyExistingUser(extUser: ExtUser): void {
    //Compte existant => envoi d'un mail de notification de creation du fournisseur
    this.sharedDataSvc.WindowLock();
    this.extUsersSvc.mailNotifyNewSupplier(extUser.Id, this.supplier.Id)
      .subscribe({
        next: result => {
          if (!result.Ok) {
            this.sharedDataSvc.alert(result.Message);
          } else {
            let nextStatutCod: string = this.supplierStatutCod;
            if (['010', '100'].indexOf(this.supplierStatutCod) >= 0) nextStatutCod = '100';
            this.suppliersSvc.ChangeStatutByCod(this.supplier.Id, this.supplier.StatutId, nextStatutCod)
              .subscribe((response: SimpleReponseResult) => {
                if (response.Ok) {
                  this.createPendingAccounts().subscribe((message: string) => {
                    this.alertEmailSentAndClose(extUser, message);
                  });
                } else {
                  this.sharedDataSvc.alert(response.Message);
                }
              });
          }
        },
        error:(reason)=>this.sharedDataSvc.alertSubscriptionReject(reason),
        complete: () => this.sharedDataSvc.WindowUnlock()
      });
  }

  createPendingAccounts(): Observable<string> {
    return this.suppliersSvc.CreatePendingAccounts(this.supplier.Id)
      .pipe(map((result: SimpleReponseResult) => result.Message));
  }

  alertEmailSentAndClose(extUser: ExtUser, messageComplementaire: string): void {
    let email: string = extUser.Email;
    if (extUser.Contact) {
      email = extUser.Contact.EmailDiff || extUser.Contact.Email;
    }   
    let msg = this.sharedDataSvc.getLoadedLabel('Le_mail_a_bien_ete_envoye');
    msg = msg.replace('{0}', email);
    if ((messageComplementaire || '') != '') {
      msg += '<BR/>' + messageComplementaire;
    }
    this.sharedDataSvc.informe(msg, (): void => {
      this.router.navigate([`suppliers`]);
    });
  }

  redirectToSuppliers(): void {
    if (this.fromScreen && ['duplicated'].indexOf(this.fromScreen) < 0) {
      this.router.navigate([`/${this.fromScreen}`]);
    } else {
      this.router.navigate([`/suppliers`]);
    }
  }



  stepperIsSelectable(step: any): boolean {
    return step.index < this.currentStep;
  }

  stepperIsDone(step: any): boolean {
    return step.index <= this.currentStep;
  }



  get maxStep(): number {
    return this.steps.length - 1;
  }
  get recapStep(): number {
    return this.steps.find(s => s.labelCod == 'Recapitulatif')?.index;
  }


  //Le code statut du fournisseur conditionne l'affichage des boutons, accès aux composants etc.
  public get supplierStatut(): SupplierStatut | null {
    if (!this.supplier) {
      return null;
    } else {
      return this.suppliersSvc.lstStatut.find(s => s.Id == this.supplier.StatutId);
    }
  }
  public get supplierPreviousStatut(): SupplierStatut | null {
    if (!this.supplier || !this.previousWf || this.previousWf.SupplierId != this.supplier.Id) {
      return null;
    } else {
      return this.suppliersSvc.lstStatut.find(s => s.Id == this.previousWf.StatutId);
    }
  }

  //Le code statut du fournisseur conditionne l'affichage des boutons, accès aux composants etc.
  public get supplierStatutCod(): string {
    return this.supplierStatut?.Cod || '';
  }

  public get supplierPreviousStatutCod(): string {
    return this.supplierPreviousStatut?.Cod || '';
  }

  public allScreensChecked: EventEmitter<void> = new EventEmitter<void>();
  public allScreensValidated: EventEmitter<void> = new EventEmitter<void>();

  get isExtranetMode(): boolean {
    return this.sharedDataSvc.portalType == 'EXTRANET';
  }

  public validateSteps(stepper: StepperComponent): void {
    this.validatedSteps.push(this.currentStep);
    stepper.validateSteps();
  }

  btnPreviousClick(): void {
    this.saveFolder('previous');
  }



  showWindowsValid(visible: boolean): void {
    if (visible && this.currentStepObject) {
      this.validationComment = '';
      let sub = this.currentStepObject.onValidityChecked.subscribe(
        {
          next: (screenValidity: detailSupplierScreenValidity) => {
            sub.unsubscribe();
            if (!screenValidity?.isValid) {
              screenValidity.showErrors();
              return;
            };
            this.windowsValid.visible = visible;
          }
        }
      );
      this.currentStepObject.raiseCheckValidity.next();
    } else {
      this.windowsValid.visible = false;
    }
  }



  btnWindowCommentSaveClick(validationComment: string): void {
    if (this.saveUnlock) {
      if (!this.currentStepObject) return;
      let param: SaveStepParam = new SaveStepParam(this.sharedDataSvc);
      param.step = this.currentStep;
      param.nextAction = 'screen';
      param.Comment = validationComment;
      this.sharedDataSvc.WindowLock();
      this.windowsValid.visible = false;
      let subSave = this.currentStepObject.stepSaved.subscribe(
        {
          next: () => {
            this.sharedDataSvc.WindowUnlock();
            subSave.unsubscribe();
          },
          error: (reason: any) => {
            this.sharedDataSvc.WindowUnlock();
            subSave.unsubscribe();
          },
        }
      );
      this.currentStepObject.saveStep.next(param);
    }
  }


  btnSaveScreenClick(): void {
    if (this.saveUnlock) {
      this.saveFolder('screen');
    }
  }

  public saveFolder(nextAction: string): void {
    if (!this.currentStepObject) return;
    this.sharedDataSvc.WindowLock();
    let sub = this.currentStepObject.onValidityChecked.subscribe({
      next: () => {
        sub.unsubscribe();
        let param: SaveStepParam = new SaveStepParam(this.sharedDataSvc);
        param.step = this.currentStep;
        param.nextAction = nextAction;
        if (nextAction == 'screen') {
          param.Comment = this.validationComment;
        }
        this.currentStepObject.saveStep.next(param);
      }
    });
    this.currentStepObject.raiseCheckValidity.next();
  }

  public saveOnStepperClick(nextStep: number): void {
    this.currentStepObject.raiseCheckValidity.next();
    //this.checkValidity(nextStep).subscribe();
  }

  public activateStep(event: StepperActivateEvent) {
    if (this.saveUnlock ||  !this.currentStepObject) {
      event.preventDefault();
      return;
    }
    let sub = this.currentStepObject.onValidityChecked.subscribe({
      next: () => {
        sub.unsubscribe();
        if (!this.canNavigateOnStepper && event.index <= this.recapStep) {
          if (this.supplier.RefStep < event.index) {
            event.preventDefault();
          } else if (this.supplier.RefStep > event.index) {
            event.preventDefault();
            this.steps[event.index].screenValidity.isValid = null;
            this.currentStep = event.index;
          }
        } else {
          if (this.supplier.RefStep != event.index) {
            this.saveOnStepperClick(event.index);
          }
        }
      }
    });
    this.currentStepObject.raiseCheckValidity.next();

  }

  public supplierStatutChanged(event: supplierStatutChangeEvent) {
    if (event.Button.ExitScreen == 1) {
      this.redirectToSuppliers();
    } else {
      let sub = this.initSupplier(this.supplier.Id, true)
        .subscribe({
          next: res => {
            sub.unsubscribe();
            if (['CTRL_QUAL', 'COMPTA'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0 && event.Button.IsPriseEnChargeBtn) {
              this.currentStep = this.steps.find(s => s.label == 'Documents_reglementaires')?.index;
            }
          }
        });
    }
  }


  get showToolbarButtons() {
    if (this.sharedDataSvc.profil?.Cod == 'ADMIN') {
      return true;
    } else if (this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR') {
      return ['100', '150', '800'].indexOf(this.supplierStatutCod) >= 0;
    } else if (['DEMANDEUR'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0) {
      return ['010', '100'].indexOf(this.supplierStatutCod) >= 0;
    } else if (['ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0) {
      //return ['010', '100','800'].indexOf(this.supplierStatutCod) >=0;
      return ['010', '100'].indexOf(this.supplierStatutCod) >= 0;
    } else {
      return this.sharedDataSvc.profil?.Cod != 'CONSULT' && this.supplierStatutCod == '800';
    }
  }

  get showBottomButtonExtranet(): boolean {
    return ['FOURNISSEUR', 'ADMIN', 'ACH_FAMHA', 'ACH_OPERAT', 'ACH_OPERAT_2'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0
      && this.currentStep <= this.recapStep;// && (['100', '150'].indexOf(this.supplierStatutCod) >= 0);
  }

  get showBtnEnvoiAuFournissseur(): boolean {
    return this.suppliersSvc.canCreateSupplier
      && this.currentStep <= this.recapStep
      && ['010', '100'].indexOf(this.supplierStatutCod) >= 0;
  }
  get showBtnEnvoiApprobation(): boolean {
    return this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR'
      && this.currentStep == this.recapStep && this.supplierStatutCod == '100';
  }

  get showBtnEnvoiComplement(): boolean {
    return this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR'
      && this.currentStep == this.recapStep && this.supplierStatutCod == '150';
  }

  //Bouton de sauvegarde de dossier pour le fournisseur encore de création
  //Avec message (je n'ai pas toutes les données,je sauvegarde en l'état et enverrai plus tard)
  get showBtnSaveSupplierFolder(): boolean {
    if (this.showSaveButton) return false;
    return this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR' && this.supplierStatutCod == '100';
  }

  //Bouton Sauvegarder le dossier
  get showSaveFolderBtn(): boolean {
    let creationOuDemandeInfo: boolean = ['100', '150'].indexOf(this.supplierStatutCod) >= 0;
    let isReferenced: boolean = this.supplierStatutCod == '800';
    let accountInfoDematAllowed: boolean
      = (this.currentStep == 1)
      && this.sharedDataSvc.checkProfilAccessPafSettings('ACCOUNT_INFO_DEMAT')
      && isReferenced;

    if (this.showSaveButton) return false; //Si on peut éditer la fiche, inutile d'afficher 'sauvegarder le dossier
    if (this.showBtnSaveSupplierFolder) return false;  //Si le fournisseur est en création, il a un libellé spécifique
    if (this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR') {
      //Le fournisseur pourra sauvegarder son dossier s'il est :
      //  - en création fournisseur
      //  - demande de complément
      //  - 

      return creationOuDemandeInfo || accountInfoDematAllowed;
    } else {
      if (['010', '100'].indexOf(this.supplierStatutCod) >= 0) {
        //Les profils qui peuvent créer un fournisseur peuvent sauvegarder le dossier lors sa création
        return this.suppliersSvc.canCreateSupplier;
      } else {
        //lors du workflow de validation, on valide via les boutons de validation WF
        //Une fois le fournisseur validé, seuls l'admin et les acheteurs peuvent apporter des modifications à la fiche
        let isAdmin: boolean = ['ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0;
        let isNotLastStep: boolean = this.currentStep < this.recapStep;
        return isReferenced && isNotLastStep &&
          (isAdmin || accountInfoDematAllowed)
        return this.supplierStatutCod == '800' && ['ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0 && this.currentStep < this.recapStep;
      }
    }
  }

  // Si on peut naviguer selon la timeline, il n'y a pas de sauvegarde entre chaque écran
  // S'il faut sauvegrder entre chaque écran, il faut passer par btnPrevious et btnNext
  get canNavigateOnStepper(): boolean {
    //if (this.saveUnlock) return false;
    if (this.supplierStatutCod == '800') return true;
    //En mode création, on autorise la navigation aux services non autorisés pour eviter d'afficher les boutons  suivant/précédent qui font une sauvegarde auto
    if (this.isCreatingSupplier) {
      return ['ADMIN', 'ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA', 'DEMANDEUR'].indexOf(this.sharedDataSvc.profil?.Cod) < 0;
    }
    //if (['FOURNISSEUR'].indexOf(this.sharedDataSvc.profil?.Cod)>=0) return false;
    if (this.sharedDataSvc.profil?.Cod == 'FOURNISSEUR') {
      return ['100', '150'].indexOf(this.supplierStatutCod) < 0;
    } else {
      return true;
    }
  }

  get isCreatingSupplier(): boolean {
    return ['010', '100'].indexOf(this.supplierStatutCod) >= 0
      && ['ADMIN', 'ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA', 'DEMANDEUR'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0;
  }

  get showPreviousBtn(): boolean {
    if (this.currentStep == 0) return false;
    return !this.canNavigateOnStepper;
  }

  get showNextButton(): boolean {
    if (this.currentStep >= this.recapStep) return false;
    return !this.canNavigateOnStepper;
  }


  get showSaveButton(): boolean {
    //Si le fournisseur en cours de validation dans le workflow, on donne acces au profil concerné par le workflow
    if (this.isCreatingSupplier || !this.currentStepObject) return false;
    if (this.suppliersSvc.canValidateWFSupplier(this.supplier)) return this.currentStepObject.showSaveButton();
    if (!(this.supplierStatutCod == '800' || (this.supplierStatutCod == '900' && this.supplierPreviousStatutCod == '800'))) return false;
    if (!this.canModifySupplier()) {
      return false;
    }
    return this.currentStepObject.showSaveButton();
  }

  unlockSaveButton(): void {
    if (!this.saveUnlock || !this.currentStepObject) {
      this.saveUnlock = true;
      this.steps.forEach((step: SupplierScreenStep) => {
        step.disabled = true;
      step.isEditing = (this.currentStepObject.index == step.index);
    });
    }
  }

  lockSaveButton(): void {
    if (!this.currentStepObject) return;
    this.showWindowsValid(false);
    this.saveUnlock = false;
    this.steps.forEach((step: SupplierScreenStep) => {
      step.disabled = false;
      step.isEditing = (this.currentStepObject.index != step.index);
  });
  }




  btnUndoSaveScreenClick(): void {
    if (this.saveUnlock) {
      if (this.currentStepObject && this.currentStepObject.onUndoScreen) {
        this.currentStepObject.onUndoScreen().then(()=>{
          this.initSupplierFromId(this.supplier.Id, true);
        });
      } else {
        this.initSupplierFromId(this.supplier.Id, true);
      }
    }
  }



  get validationDisabled(): boolean {
    return this.steps.some(s => s.screenValidity.isValid == false && s.label != 'Documents_qualite');
  }

  validationclickconfirmSubject: Subject<void> = new Subject<void>();
  //Gestion de la demande de validation depuis la barre d'outils
  beforevalidateclick(beforevalidateclick: BeforeValidateClickEvent): void {
    let screenRegulDoc: SupplierScreenStep = this.steps.find(s => s.label == 'Documents_reglementaires');
    const profilMustValidateReguDocs: boolean = (['COMPTA', 'CTRL_QUAL'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0);
    if (profilMustValidateReguDocs) {
      if (screenRegulDoc.screenValidity.isValid == null) {
        beforevalidateclick.cancel = true;
        if (this.currentStep != screenRegulDoc.index) {
          this.sharedDataSvc.alert('Veuillez d\'abord contrôler l\'onglet des documents réglementaires.');
          this.currentStep = screenRegulDoc.index;
          return;
        } else {
          let validationSubscription: Subscription = screenRegulDoc.screenValidity.validationChange
            .subscribe((isvalid: boolean) => {
              validationSubscription.unsubscribe();
              if (isvalid) {
                this.validationclickconfirmSubject.next();
              }
            });
          this.steps[screenRegulDoc.index].raiseCheckValidity.next();
        }
      }
      if (screenRegulDoc.screenValidity.isValid == false) {
        this.sharedDataSvc.alert('Impossible de valider si l\'onglet des documents réglementaires n\'est pas validé');
        beforevalidateclick.cancel = true;
        return;
      }
    }
  }

  canModifySupplier(): boolean {
    if (this.suppliersSvc.canValidateWFSupplier(this.supplier)) return true;
    if (!this.sharedDataSvc) return false;
    if (!this.sharedDataSvc.profil) return false;
    switch (this.sharedDataSvc.profil?.Cod) {
      case 'ADMIN':
        return (this.supplierStatutCod!='910');
      case 'FOURNISSEUR':
        // Si le fournisseur est supendu, il peut quand même modifier ses documents
        if (this.isSuspendedSupplier) {
          return [3, 4].some(i => this.currentStepObject?.index == i)
        }
        return (['100', '150', '800'].indexOf(this.supplierStatutCod) >= 0);
      case 'DEMANDEUR':
        return (['010', '100'].indexOf(this.supplierStatutCod) >= 0);
      case 'ACH_OPERAT':
      case 'ACH_FAMHA':
      case 'ACH_OPERAT_2':
        return (
          (['010', '100', '800'].indexOf(this.supplierStatutCod) >= 0)
          ||
          //Ticket 320 : si fournisseur suspendu, les acheteurs 1, 2 et familles peuvent modifier les docs règlementaires si le statut précédent était référencé
          (this.isSuspendedSupplier && [3, 4].some(i => this.currentStepObject?.index == i))
        );
      case 'CTRL_QUAL':
      case 'COMPTA':
      case 'QUAL':
      case '3SE':
        return this.supplierStatutCod == '800';
      default:
        return false;
    }
  }



  get codeTiersDisabled(): boolean {
    if (!this.canModifySupplier()) return true;
    return !this.sharedDataSvc.checkProfilAccessPafSettings('UPDATE_NUMTIERS');
    //return ['COMPTA', 'ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod) < 0;
  }


}

